import { Car } from 'lucide-react';
import Button from 'shared/components/Button';
import { EventModel, EventTransferReservationModel } from 'app/eventos/models/Evento';
import { FC } from 'react';
import { ViajeTrasladoEstado } from 'app/viaje/models';
import { ReservationsViews } from 'app/eventos/pages/EventoDetailPage';

interface EventReservesProps {
    event: EventModel;
    handleReservationClick: (reservation: EventTransferReservationModel, view: ReservationsViews) => void;
    handleCreateReserve: () => void;
}
const EventReserves: FC<EventReservesProps> = ({ event, handleReservationClick, handleCreateReserve }) => {
    const pendingReservations: EventTransferReservationModel[] = []
    const openedReservations: EventTransferReservationModel[] = []
    const closedReservations: EventTransferReservationModel[] = []

    event.transferReservations.map((reservation) => {
        if (reservation.status.name === ViajeTrasladoEstado.PENDIENTE || reservation.status.name === ViajeTrasladoEstado.CREADA) {
            pendingReservations.push(reservation)
        } else if (reservation.status.name === ViajeTrasladoEstado.ASIGNADA || reservation.status.name === ViajeTrasladoEstado.ACEPTADA || reservation.status.name === ViajeTrasladoEstado.EN_VIAJE_A_ORIGEN || reservation.status.name === ViajeTrasladoEstado.ANUNCIADO || reservation.status.name === ViajeTrasladoEstado.INICIO_ESPERA || reservation.status.name === ViajeTrasladoEstado.EN_VIAJE_A_DESTINO) {
            openedReservations.push(reservation)
        } else {
            closedReservations.push(reservation)
        }
    })

    return (
        <div className="flex flex-col gap-4 rounded-2xl border border-white bg-whiteLight p-6 dark:border-white/10 dark:bg-darkLight">
            <div className="flex justify-between">
                <div className="flex items-center gap-2">
                    <Car size={18} className="text-secondary-500" />
                    <h2 className="text-lg font-semibold text-ink dark:text-ink-dark">
                        Reservas
                    </h2>
                </div>
                <div className="flex items-center gap-4">
                    <Button
                        onClick={handleCreateReserve}
                        disabled={!event.isActive}
                    >
                        Crear Nueva Rereserva
                    </Button>
                </div>
            </div>
            {event.transferReservations.length === 0 ? (
                <p className="text-sm text-secondary-500 dark:text-secondary-300">
                    No hay reservas asociadas a este evento
                </p>
            ) :
                <div className='grid grid-cols-12 gap-4'>
                    <div className="col-span-3 flex flex-wrap gap-0.5 border-2 border-secondary-300 dark:border-dark-600 relative px-1 py-2 rounded-xl">
                        <div className='absolute left-1/2 -translate-x-1/2 text-xs font-medium text-secondary-500 dark:text-secondary-300 px-2 bg-whiteLight dark:bg-dark-600  rounded-full' style={{ top: '-10px' }}>En Pendientes</div>
                        <div className="flex flex-wrap gap-0.5">
                            {pendingReservations.map((reservation) => (
                                <ReservationButton key={reservation.id} reservation={reservation} onClick={handleReservationClick} view={ReservationsViews.PENDIENTE} />
                            ))}
                        </div>
                    </div>
                    <div className="col-span-6 flex flex-wrap gap-2 border-2 border-secondary-300 dark:border-dark-600 relative p-2 rounded-xl">
                        <div className='absolute left-1/2 -translate-x-1/2 text-xs font-medium text-secondary-500 dark:text-secondary-300 px-2 bg-whiteLight dark:bg-dark-600  rounded-full' style={{ top: '-10px' }}>En Abiertos</div>
                        {openedReservations.map((reservation) => (
                            <ReservationButton key={reservation.id} reservation={reservation} onClick={handleReservationClick} view={ReservationsViews.ABIERTO} />
                        ))}
                    </div>
                    <div className="col-span-3 flex flex-wrap gap-2 border-2 border-secondary-300 dark:border-dark-600 relative p-2 rounded-xl">
                        <div className='absolute left-1/2 -translate-x-1/2 text-xs font-medium text-secondary-500 dark:text-secondary-300 px-2 bg-whiteLight dark:bg-dark-600  rounded-full' style={{ top: '-10px' }}>En Cerrados</div>
                        {closedReservations.map((reservation) => (
                            <ReservationButton key={reservation.id} reservation={reservation} onClick={handleReservationClick} view={ReservationsViews.CERRADO} />
                        ))}
                    </div>
                </div>
            }
        </div>
    );
};

export default EventReserves;


const ReservationButton = ({ reservation, onClick, view }: { reservation: EventTransferReservationModel, onClick: (reservation: EventTransferReservationModel, view: ReservationsViews) => void, view: ReservationsViews }) => {
    return (
        <button
            key={reservation.id}
            type="button"
            onClick={() => onClick(reservation, view)}
            className="flex items-center h-6 gap-2 rounded-full border border-line bg-white px-2 py-0.5 text-sm font-medium text-ink transition hover:border-secondary-500 hover:text-secondary-500 dark:border-white/10 dark:bg-white/10 dark:text-ink-dark white-space-nowrap"
        >
            #{reservation.id}
            {reservation.status.name!=='Creada' && (<span className="text-secondary-500 dark:text-secondary-300 white-space-nowrap">
                {reservation.status.name}
            </span>)}
        </button>
    );
};